import styled from 'styled-components'

export const MainContainer = styled.div`
  padding: 15px;
  width: 85vw;
  overflow-x: auto;
`;

export const TopDiv = styled.div`
	display: flex;
	justify-content: space-between;
  overflow-x: auto;
`;

export const SelectorContainer = styled.div`
	display: flex;
`;

export const Selector = styled.div`
	display: flex;
  flex-direction: column; 
`;

export const Header = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : center;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const NewHeader = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const GraphContainer = styled.div`
  display: grid;
  grid-template-columns: 49% 2% 49%;
  height: 38vh;
  margin-bottom: 10px;
`;

export const GraphContainerFull = styled.div`
  display: grid;
  height: 38vh;
  margin-bottom: 10px;
`;

export const GraphDiv = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 5px;  
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const GraphDivLabelDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LabelHeading = styled.div`
  font-size: 15px;
  color: #02475c;
`;

export const GraphMonthSelector = styled.div`
  padding: 7px;
  border-radius: 5px;
  border: 1px solid whitesmoke;
  font-size: 12px;
  color: grey;
`;

export const Icon = styled.a`
  cursor: pointer;
  color: grey;
  font-size: large;

  &:hover {
    color: #02475c;
    font-weight: bold; 
    transition: transform 0.3s ease;
  }
`;

export const PercentDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 5px;
  padding-left: 5px;
  min-width: 50px;
  border-radius: 5px;
  align-items: center;
  cursor: pointer;
`

export const RevenueCol = styled.div`
  display: flex;               
  justify-content: flex-end;   
  align-items: center;         
  column-gap: 4px; 
`;

export const RenewalTableHeader = styled.div`
  display: flex;  
  align-items: center;
  justify-content: ${props=>props.hasInfo ? 'space-between' : 'center'};
`

export const RetentionField = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px;
  background: ${props=> props.value !== null && props.value !== undefined ? 
                  (props=>  props.value >= 80 ? '#8fe292' : 
                            props.value >= 50 ? '#e8ff9d' : 
                            props.value >= 30 ? '#ffcc80' : '#f96464') 
                : 'transparent'
              };
`

export const RightArrowCol = styled.div`
  color: #02475c;
  cursor: pointer;
`

export const RatingGraphDiv = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 5px;  
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 500px;
`;
